import React, { useRef, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Checkbox, message as Message } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import i18n from 'i18next';

import { GlobalModalClose } from '../../layout/GlobalModal';
import { MealParams } from './MealDetails';

import { getAppGlobalState } from '../../../store/app-globals/selectors';
import { setMealVisibility } from '../../../store/meals/actions';
import { updatePreferences } from '../../../store/settings/actions';

import EyeSlashIcon from '../../../assets/images/png/eye-slash.png';

export const VisibilityModal: React.FC<MealParams> = ({ meal }) => {
  const { isLoading, hasError } = useSelector(getAppGlobalState);
  const [checked, setChecked] = useState(false);
  const dispatch = useDispatch();
  const IsUpdatingMeal = useRef(false);

  const onCheckboxChange = (e: CheckboxChangeEvent): void => {
    setChecked(e.target.checked);
  };

  const handleContinueButton = () => {
    const body = { mealid: meal?.id, visible: false };
    dispatch(setMealVisibility(body));

    if (checked) {
      dispatch(updatePreferences({ mealInvisibleMessage: false }));
    }
    IsUpdatingMeal.current = true;
  };

  const updatingMeal = () => {
    if (IsUpdatingMeal.current && !isLoading && !hasError) {
      GlobalModalClose();
    }
    if (IsUpdatingMeal.current && !isLoading && hasError) {
      Message.error('Somwething went wrong');
    }
  };
  useEffect(updatingMeal, [isLoading]);
  return (
    <div className="modal-content-wrapper">
      <div className="modal-content-icon">
        <img src={EyeSlashIcon} alt="modal-content-icon" />
      </div>
      <div className="modal-content-description">
        <span>{i18n.t('SET_VISIBLE')}</span>
        <div className="modal-content-extra-text margin-top">
          {i18n.t('VISIBLE_MESSAGE')}
        </div>
      </div>
      <div className="modal-content-description">
        <Checkbox
          checked={checked}
          onChange={onCheckboxChange}
          className="modal-content-checkbox-label"
        >
          {i18n.t('DONT_SHOW_AGAIN')}
        </Checkbox>
      </div>
      <div className="button-container">
        <Button
          block
          type="primary"
          shape="round"
          className="continue-button continue-button-primary"
          onClick={handleContinueButton}
          disabled={isLoading}
          loading={isLoading}
        >
          <span className="continue-button-text">{i18n.t('Continue')}</span>
        </Button>
      </div>
    </div>
  );
};
